module.exports = __webpack_public_path__ + "static/img/newbook.1d63ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/newbook.png
// module id = i5N4
// module chunks = 0